<template>
  <div
    class="container"
    :style="maxWidth ? { 'max-width': `${maxWidth}px` } : {}"
    :class="{ centered: center }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  maxWidth?: number
  center?: boolean
}>()
</script>

<style scoped>
.container {
  padding: 30px;
  box-sizing: border-box;
}

.centered {
  margin-left: auto;
  margin-right: auto;
}

@media screen and (min-width: 640px) {
  .container {
    padding: 30px 50px;
  }
}
</style>
